import OptimizationBody from './OptimizationBody';

export default OptimizationBody;
